/* eslint-disable @typescript-eslint/no-explicit-any */
import { Middleware } from 'redux';
import { AppActions } from './types';
import { LOGOUT_SUCCESS, SET_CORRELATION_ID, SHOW_GLOBAL_ERROR, SHOW_TOAST } from './types/auth';
import en from '../lang/en-us';
import {
  SEND_CONSENTEMAIL_APPROVE_SUCCESS,
  SEND_CONSENTEMAIL_REJECT_SUCCESS,
} from './types/onBoarding';
import { CONTENT_TYPE } from '../utils/constant';

export const CALL_API = 'CALL_API';
export const BASE_URL = process.env.REACT_APP_BASE_URL || '/api';
const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Expires: 0,
};

class AuthError extends Error { }

class APIError extends Error { }

class SlientError extends Error { }
export class fatcaErrors extends Error { }
export class AuthorisedErrors extends Error { }
export class UboErrors extends Error { }
export class BankError extends Error { }
export class RelatedPersonError extends Error { }
export class RiskProfileErrors extends Error { }
interface CustomError {
  error: boolean;
  message: string;
  code: number;
}

export interface ResponseBody<T> {
  type: AppActions;
  body: T;
  error?: any;
}

// interface ApiResBody {
//     data: any;
//     count: number;
//     error: string[];
//     success: boolean;
// }

export interface ResponseType {
  data: any;
  error: null | CustomError;
}

export interface ActionReqType {
  types: string[];
  body?: any;
  enableFixture?: boolean;
  json?: string;
  url: string;
  method: 'POST' | 'GET' | 'PUT' | 'DELETE';
  contentType?: any;
  showToast?: boolean;
  toastMessage?: string;
  params?: any;
  slient?: boolean;
  modifyUrl?: boolean;
  temporaryToken?: string
}

async function invokeAPI({
  endpoint,
  token,
  config,
  headerContent,
  enableFixture,
  json,
  contentType,
  modifyUrl,
  correlationId
}: {
  endpoint: string;
  token: string;
  config: any;
  headerContent?: any;
  enableFixture?: boolean;
  json?: string;
  contentType?: any;
  modifyUrl: boolean;
  correlationId: string | null
}): Promise<ResponseType> {

  const baseHeaders = {
    ...(config.body instanceof FormData ? {} : DEFAULT_HEADERS),
    ...(token && { Authorization: `Bearer ${token}` })
  };
  const headers = {
    ...baseHeaders,
    ...headerContent,
    'Correlation-Id': correlationId
  };
  const updatedConfig = {
    ...config,
    headers,
  };
  const url = enableFixture ? `/fixtures/${json}` : `${BASE_URL}${endpoint}`;
  const modifiedUrl = modifyUrl ? url.replace("/api", "") : url
  const response = enableFixture ? await fetch(modifiedUrl) : await fetch(modifiedUrl, updatedConfig);

  if (response.status === 401) {
    throw new AuthError(en.networkText.timeOut);
  }

  let body: any;
  if (typeof contentType === 'undefined') {
    body = await response.json();
  } else if (contentType === CONTENT_TYPE.PDF) {
    body = await response.blob();
  } else if (contentType === CONTENT_TYPE.EXCEL) {
    body = await response.blob();
  }

  if (response.status >= 400) {
    const { message } = body || {};
    throw new APIError(message || en.networkText.unableToProcess);
  }

  return { data: body, error: null };
}

export const middleWareDispatch: Middleware = (store) => (next) => async (action) => {
  if (typeof action[CALL_API] === 'undefined') {
    return next(action);
  }
  const { slient = false } = action[CALL_API];
  try {
    const {
      url,
      types,
      body,
      method,
      json,
      enableFixture = false,
      contentType,
      params,
      showToast = false,
      toastMessage = 'Success!',
      modifyUrl = false,
      temporaryToken
    }: ActionReqType = action[CALL_API];

    const queryParams = new URLSearchParams();
    for (const param in params) {
      if (params[param]) {
        queryParams.set(param, params[param]);
      }
    }
    const [successType, errorType] = types;
    const {
      auth: { token = '', correlationId: existingCorrelationId = null },
      investor: { token: investorToken = '' },
    } = store.getState();

    const tokenToUse =
      temporaryToken ? temporaryToken :
        types.includes(SEND_CONSENTEMAIL_APPROVE_SUCCESS) ||
          types.includes(SEND_CONSENTEMAIL_REJECT_SUCCESS)
          ? ''
          : token || investorToken;

    // Correlation Id Start 
    let correlationId = existingCorrelationId;

    try {
      if (!correlationId) {
        correlationId = `${window.crypto.randomUUID()}-${new Date().getTime()}`

        next({
          type: SET_CORRELATION_ID,
          correlationId,
        });
      }
    } catch (error) {
      correlationId = `${Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000}-${new Date().getTime()}`

      next({
        type: SET_CORRELATION_ID,
        correlationId
      });

    }
    // Correlation Id End 

    const requestBody = body instanceof FormData
      ? body
      : JSON.stringify(body);

    const payload = {
      endpoint: url + (params ? '?' + queryParams.toString() : ''),
      token: tokenToUse,
      config: {
        method,
        body: requestBody,
        ...(body instanceof FormData && { headers: {} })
      },
      enableFixture,
      json,
      contentType,
      modifyUrl,
      correlationId
    };
    const { data, error }: ResponseType = await invokeAPI(payload);
    if (showToast) {
      next({
        type: SHOW_TOAST,
        message: toastMessage,
        severity: 'success',
      });
    }
    if (data || !error) {
      next({ type: successType, body: data });
    } else {
      next({ type: errorType, error });
    }
    return data;
  } catch (error) {
    if (error instanceof AuthError) {
      next({ type: LOGOUT_SUCCESS });
      next({ type: SHOW_GLOBAL_ERROR, errorType: 'ALERT', message: en.networkText.timeOut });
    } else if (slient || error instanceof SlientError) {
      throw error;
    } else if (error instanceof APIError) {
      next({ type: SHOW_GLOBAL_ERROR, errorType: 'ALERT', message: (error as Error).message });
      // throw error;
    } else {
      next({
        type: SHOW_GLOBAL_ERROR,
        errorType: 'ALERT',
        message: window.navigator.onLine ? en.networkText.unableToProcess : en.networkText.noInternet,
      });
      throw error;
    }
  }
};
